import { getCssVariables } from "@config/theme/css-variables";
import type { ThemeMode } from "@config/theme/tokens";

export function applyThemeCssVariables(mode: ThemeMode = "light"): void {
	const root = document.documentElement;
	const variables = getCssVariables(mode);

	root.setAttribute("data-theme", mode);
	root.style.colorScheme = "light";

	for (const [name, value] of Object.entries(variables)) {
		root.style.setProperty(name, value);
	}
}

export function bootstrapTheme(): ThemeMode {
	const mode: ThemeMode = "light";
	applyThemeCssVariables(mode);
	return mode;
}
